export default __webpack_public_path__ + "static/media/login-layout.5d9deed5.webp";